import ServicesConfig from '@/config/ServicesConfig';
import Axios from 'axios';
import querystring from "querystring"
import ComunServices from "@/services/ComunServices";
const followRedirects = require('follow-redirects');
followRedirects.maxBodyLength = 100 * 1024 * 1024; // 100 MB
Axios.defaults.maxContentLength = Infinity

export default {
	
	getCartera(filters) {
		let url = '/getCartera';
		filters.provision = !filters.provision ? "": filters.provision;
		filters.lineaNegocio = !filters.lineaNegocio ? "": filters.lineaNegocio;
		filters.sucursal = !filters.sucursal ? "": filters.sucursal;
		
		let res = Axios.get(url, {
			params: filters
		})
		
		return res
	},

	getCarteraExcel(filters) {		

		let url = '/getCarteraExcel';
		filters.provision = !filters.provision ? "": filters.provision;
		filters.sucursal = !filters.sucursal ? "": filters.sucursal;

		return Axios.get(url , {
			responseType: 'arraybuffer',
			params: filters
		});
	},

	getAgencias() {

		let url = '/getAgencias';
		return Axios.get(url)
	},

	getLineasNegocio() {

		let url = '/getLineasNegocio';
		return Axios.get(url)
	},
}